var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.31896L12.0154 7.76545L12.0746 7.92542L12.2346 7.98462L17.681 10L12.2346 12.0154L12.0746 12.0746L12.0154 12.2346L10 17.681L7.98462 12.2346L7.92542 12.0746L7.76545 12.0154L2.31896 10L7.76545 7.98462L7.92542 7.92542L7.98462 7.76545L10 2.31896Z",
    fill: "#FFF500",
    stroke: "#FFF500",
    strokeWidth: 0.741939
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 2.31896L16.1211 3.65971L16.1803 3.81968L16.3403 3.87888L17.681 4.375L16.3403 4.87112L16.1803 4.93032L16.1211 5.09029L15.625 6.43104L15.1289 5.09029L15.0697 4.93032L14.9097 4.87112L13.569 4.375L14.9097 3.87888L15.0697 3.81968L15.1289 3.65971L15.625 2.31896Z",
    fill: "#FFF500",
    stroke: "#FFF500",
    strokeWidth: 0.741939
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.d9682ac3eef0cebb1d3fed0276342815.svg";
export { ForwardRef as ReactComponent };